export const app = {
  productMountEl: '.js-product-app',
  topRecommendationsMountEl: '#js-top-product-recommendations'
}

export const data = {
  applicationData: '#applicationData',
  productDescription: '#text-product-description',
  mdProductDetail: '#md-product-detail',
  productCategoryAttributes: '#array-product-category-attributes',
  productAiTemplateUrl: '#text-product-aiTemplateUrl',
  currentUser: '#currentUser'
}
